import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import Login from './components/Login';
import ForgetPassword from './components/ForgotPassword';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import MultiSelectField from './components/multiselect';
import CreateEdit from './components/createEdit';
import Subscriptions from './components/Subscription';
import Account from './components/myaccount';
//import App from './App'
// import * as serviceWorker from './serviceWorker';

const routing = (
    <Router>
        <div>
            <Route exact path="/" component={Dashboard} />
            <Route exact path="/asd-login" component={Login} />
            <Route exact path="/lostpassword" component={ForgetPassword} />
            <Route exact path="/users" component={Users} />
            <Route exact path="/multiselect" component={MultiSelectField} />
            <Route exact path="/myaccount" component={Account} />
            <Route exact path="/create-edit" component={CreateEdit} />
            <Route exact path="/subscriptions" component={Subscriptions} />

        </div>
    </Router>
)

ReactDOM.render(routing, document.getElementById('root'));
// ReactDOM.render(<App />, document.getElementById('root'));

